import { useSeason } from './context';
import { LOOKS } from './looks';

/**
 * A named place a page lends to the active season's look (the home hero's
 * backdrop, the 404 illustration). Renders nothing when no season is on or
 * the look has nothing for this slot.
 */
export function SeasonalSlot({ name }: { name: string }) {
  const { season } = useSeason();
  const Piece = season ? LOOKS[season.look]?.slots?.[name] : undefined;
  return Piece ? <Piece /> : null;
}
